/* "Save for later" on cart line items (cart page and cart drawer).
   Moves the product to the wishlist, then removes the line from the cart.
   The wishlist is the same localStorage list the heart buttons and the wishlist page use.
   Kept in its own file (loaded with a versioned URL) on purpose: files that theme.js imports are cached for a year. */
(function () {
  if (customElements.get("save-for-later")) return;

  var STORAGE_KEY = "hyperlink__wishlist-items";

  function saveProductToWishlist(productId) {
    var id = String(productId);
    var ids;
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      ids = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(ids)) ids = [];
      ids = ids.map(String);
      if (ids.indexOf(id) === -1) ids.push(id);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
      // make sure it really was stored before the item is taken out of the cart
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]").map(String);
      if (stored.indexOf(id) === -1) return false;
    } catch (e) {
      return false;
    }
    // header count and any heart button for this product
    document.querySelectorAll(".wishlist-count").forEach(function (el) {
      el.innerText = ids.length;
    });
    document
      .querySelectorAll('button-wishlist[data-product-id="' + id + '"]')
      .forEach(function (el) {
        el.classList.add("active");
      });
    return true;
  }

  class SaveForLater extends HTMLElement {
    constructor() {
      super();
      this.busy = false;
      this.addEventListener("click", this.onClick.bind(this));
    }

    get link() {
      return this.querySelector(".save-for-later__link");
    }

    setStatus(text) {
      var statusEl = this.querySelector(".save-for-later__status");
      if (!statusEl) return;
      statusEl.textContent = text || "";
      statusEl.hidden = !text;
    }

    reset(errorText) {
      this.busy = false;
      var button = this.activeButton || this.link;
      if (button) {
        if (this.label) button.textContent = this.label;
        button.removeAttribute("aria-disabled");
      }
      this.activeButton = null;
      this.hidePrompt();
      this.setStatus(errorText);
    }

    // Same prompt, two wordings: "save" when "Save for later" opened it, "trash" when the trash icon did
    setPromptText(container, kind) {
      var text = container && container.querySelector(".save-for-later__prompt-text");
      if (!text) return;
      var value = kind === "trash" ? text.dataset.textTrash : text.dataset.textSave;
      if (value) text.textContent = value;
    }

    // Cart page only: the trash icon asks "add to wishlist before remove?" (the drawer has its own prompt)
    showPrompt(kind) {
      var prompt = this.querySelector(".save-for-later__prompt");
      if (!prompt) return false;
      this.setPromptText(prompt, kind);
      if (this.link) this.link.hidden = true;
      this.setStatus("");
      prompt.hidden = false;
      var row = this.closest("tr.cart-item");
      if (row) row.classList.add("is-save-prompting");
      var yes = prompt.querySelector(".save-for-later__yes");
      if (yes) yes.focus();
      return true;
    }

    // Cart drawer: the theme's own "add to wishlist before remove?" prompt for this line
    showDrawerPrompt(kind) {
      var item = this.closest(".cart-item");
      var prompt = item && item.querySelector(".minicart__wishlist");
      if (!prompt) return false;
      this.setPromptText(prompt, kind);
      var info = item.querySelector(".minicart__product-info");
      if (info) info.style.display = "none";
      prompt.style.display = "block";
      return true;
    }

    hidePrompt() {
      var prompt = this.querySelector(".save-for-later__prompt");
      if (prompt) prompt.hidden = true;
      if (this.link) this.link.hidden = false;
      var row = this.closest("tr.cart-item");
      if (row) row.classList.remove("is-save-prompting");
    }

    removeFromCart() {
      var cartItems =
        this.closest("cart-items") ||
        this.closest("cart-drawer-items") ||
        this.closest("cart-notification");
      if (!cartItems || typeof cartItems.updateQuantity !== "function") return false;
      cartItems.updateQuantity(this.dataset.index, 0);
      return true;
    }

    onClick(event) {
      var target = event.target.closest ? event.target : event.target.parentElement;
      var yes = target.closest(".save-for-later__yes");
      var no = target.closest(".save-for-later__no");
      var cancel = target.closest(".save-for-later__cancel");
      if (cancel) {
        event.preventDefault();
        this.hidePrompt();
        return;
      }
      if (no) {
        event.preventDefault();
        if (this.busy) return;
        this.busy = true;
        if (!this.removeFromCart()) this.reset(this.dataset.errorText);
        return;
      }
      var link = target.closest(".save-for-later__link") || (yes ? yes : null);
      if (!link) return;
      event.preventDefault();
      if (this.busy) return;
      // "Save for later" asks the same question as the trash icon (unless the product is already saved)
      if (
        link.classList.contains("save-for-later__link") &&
        this.dataset.prompt === "true" &&
        !isInWishlist(this.dataset.productId)
      ) {
        if (this.showPrompt("save") || this.showDrawerPrompt("save")) return;
      }
      this.busy = true;
      this.label = link.textContent;
      link.textContent = this.dataset.savingText || this.label;
      link.setAttribute("aria-disabled", "true");
      this.activeButton = link;
      this.setStatus("");

      // 1. add it to the wishlist; if that fails the item stays in the cart
      if (!saveProductToWishlist(this.dataset.productId)) {
        this.reset(this.dataset.errorText);
        return;
      }

      // 2. it is saved, so take the line out of the cart (the same call the remove button uses)
      if (!this.removeFromCart()) {
        this.reset(this.dataset.errorText);
        return;
      }
      // the cart re-renders and replaces this line; if that did not happen, give the link back
      var self = this;
      setTimeout(function () {
        if (self.isConnected) self.reset();
      }, 8000);
    }
  }

  customElements.define("save-for-later", SaveForLater);

  function isInWishlist(productId) {
    try {
      var ids = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(ids) && ids.map(String).indexOf(String(productId)) !== -1;
    } catch (e) {
      return false;
    }
  }

  // Cart page: ask before the trash icon removes a product that is not on the wishlist yet.
  // (Products already on the wishlist are removed straight away, like in the drawer.)
  document.addEventListener(
    "click",
    function (event) {
      var button = event.target.closest && event.target.closest("cart-remove-button");
      if (!button) return;
      var row = button.closest("tr.cart-item");
      var sfl = row && row.querySelector("save-for-later");
      if (!sfl || sfl.dataset.prompt !== "true" || sfl.busy) return;
      if (isInWishlist(sfl.dataset.productId)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      sfl.showPrompt("trash");
    },
    true
  );

  // Drawer: the theme's own code opens the prompt when the trash icon is clicked; make sure it uses the trash wording
  document.addEventListener(
    "click",
    function (event) {
      var button = event.target.closest && event.target.closest("mini-cart-remove-button");
      var item = button && button.closest(".cart-item");
      var text = item && item.querySelector(".minicart__wishlist .save-for-later__prompt-text");
      if (text && text.dataset.textTrash) text.textContent = text.dataset.textTrash;
    },
    true
  );
})();
